import React from "react";
import { CommonDialog, CommonDialogContent, CommonDialogTitle } from "../../../common/dialogs";
import { useIntl, FormattedMessage } from "react-intl";
import { Typography } from "@mui/material";
import { TextInput } from "../../../common/form-controls";
import { Box } from "@mui/material";
import { Button } from "@mui/material";

type ApproveRequestWithConflictsDialogProps = {
    open: boolean;
    onClose: () => void;
    approveMessage: string;
    setApproveMessage: (value: string) => void;
    onSave: () => void;
};

const ApproveRequestWithConflictsDialog: React.FC<ApproveRequestWithConflictsDialogProps> = ({ onClose, open, approveMessage, setApproveMessage, onSave }) => {
    const intl = useIntl();

    return (
        <CommonDialog open={open}>
            <CommonDialogTitle withoutCloseIcon={false} onClose={onClose} title={intl.formatMessage({ id: "approve-request-with-conflicts-dialog.title" })} />
            <CommonDialogContent>
                <Typography sx={{ textAlign: "center", marginTop: "10px", marginBottom: "10px" }}><FormattedMessage id="approve-request-with-conflicts-dialog.warning-text" /></Typography>
                <TextInput multiline={true} rows={3} value={approveMessage} onChange={(event) => setApproveMessage(event.target.value)} />
                <Box gap={2} sx={{ marginTop: "15px" }} justifyContent="flex-end" display="flex">
                    <Button
                        disabled={false}
                        variant="outlined"
                        onClick={onClose}
                        sx={{
                            color: "var(--font-4)",
                            borderColor: "var(--font-4)",
                        }}
                    >
                        <FormattedMessage id="common.btn-cancel" />
                    </Button>
                    <Button
                        disabled={!(approveMessage.length > 0)}
                        variant="contained"
                        sx={{
                            color: "var(--bg-2)",
                            backgroundColor: "var(--font-2)",
                            "&:hover": {
                                backgroundColor: "var(--font-2)",
                            },
                        }}
                        onClick={onSave}
                    >
                        <FormattedMessage id="approve-request-with-conflicts-dialog.btn-continue" />
                    </Button>
                </Box>
            </CommonDialogContent>
        </CommonDialog>
    );
};

export default ApproveRequestWithConflictsDialog;
